module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPatient-container"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('el-card', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-left"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Patient Profile')))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('uername')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.username))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.$t('alias')) + ": ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alias),
      expression: "alias"
    }],
    staticClass: "alias",
    attrs: {
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.alias)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.alias = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isA),
      expression: "isA"
    }]
  }, [_vm._v("Patient ID:"), _c('span', {
    staticStyle: {
      "margin-left": "36px"
    }
  }, [_vm._v("0000001")])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content content1",
    class: {
      'sw1': _vm.isSw
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Portrait')) + ":")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.portrait
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('fullName')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.profile.realname))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isM),
      expression: "isM"
    }],
    staticStyle: {
      "margin-left": "105px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.Remark = true
      }
    }
  }, [_vm._v("Remark: "), _c('span', [_vm._v("Jack")])])]), _vm._v(" "), _c('div', {
    staticClass: "content content1"
  }, [_c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('gender')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v(_vm._s(_vm.profile.gender))])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('height'))), _c('span', [_vm._v(_vm._s(_vm.profile.height))])]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t('weight'))), _c('span', [_vm._v(_vm._s(_vm.profile.weight))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('birthday')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.birthday))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content content1 content2",
    class: {
      'sw2': _vm.isSw
    }
  }, [_c('p', {
    staticClass: "text2"
  }, [_vm._v(_vm._s(_vm.$t('disType')) + ":"), _c('span', {
    staticStyle: {
      "margin-left": "25px"
    }
  }, [_vm._v(_vm._s(_vm.profile.diabetes_type))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('disDate')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.date))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "content content3"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Address')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.address))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Postcode')) + ": "), _c('span', [_vm._v(_vm._s(_vm.profile.zipcode))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Mobile')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.mobile))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Telephone')) + ": "), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.profile.telephone))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Email')) + ":"), _c('span', [_vm._v(_vm._s(_vm.profile.email))])])]), _vm._v(" "), _c('hr', {
    staticClass: "small-hr"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "item1"
  }, [_c('span', {
    class: {
      'es1': _vm.isEs || _vm.isDe || _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Inpatient')))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.inHospital),
      expression: "profile.inHospital"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.profile.inHospital = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v(_vm._s(_vm.$t('Yes')))]), _c('option', [_vm._v(_vm._s(_vm.$t('No')))])])]), _vm._v(" "), _c('div', {
    staticClass: "item1"
  }, [_c('span', {
    class: {
      'po1': _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Pno')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.patientNo),
      expression: "profile.patientNo"
    }],
    domProps: {
      "value": (_vm.profile.patientNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.patientNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item1 spe-item1"
  }, [_c('span', {
    class: {
      'po1': _vm.isPo || _vm.isCz
    }
  }, [_vm._v(_vm._s(_vm.$t('Bno')))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profile.bedNo),
      expression: "profile.bedNo"
    }],
    domProps: {
      "value": (_vm.profile.bedNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.profile.bedNo = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('Cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "create",
    on: {
      "click": _vm.create
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.Remark,
      "size": "tiny",
      "id": "remark-form",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.Remark = $event
      }
    }
  }, [_c('div', {
    staticClass: "patientList-dialog-title",
    slot: "title"
  }, [_c('span', [_vm._v("Set remark")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/cancel.png")
    },
    on: {
      "click": _vm.cancel
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dialog-body",
    slot: "default"
  }, [_c('p', [_vm._v("Please input remark in the following box")]), _vm._v(" "), _c('input')]), _vm._v(" "), _c('div', {
    staticClass: "patientList-dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "confirmButton"
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "cancelButton",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1eae045a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/profile-templates/patientProfile-noEdit.vue
// module id = 1430
// module chunks = 7